import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
import { param2Obj } from '@/tool/index'

// 开发  development
// 生产  production
// console.log(Vue);
// let env = 'production'

let errorNum = 0

if (!Vue.prototype.$axios) {
  Vue.prototype.$axios = axios
  axios.defaults.timeout = 50000

  // 设置集团id
  const params = param2Obj(window.location.href)
  if (params.grpid && params.comId && !(localStorage.getItem('grpid') && localStorage.getItem('comId'))) {
    localStorage.setItem('grpid', params.grpid)
    localStorage.setItem('comId', params.comId)
  }
  axios.defaults.headers['X-Auth-Grpid'] = localStorage.getItem('grpid') || localStorage.getItem('huli_grpid') // 国康
  axios.defaults.headers['X-Auth-ComId'] = localStorage.getItem('comId') || localStorage.getItem('huli_grpid')
  axios.defaults.headers['X-Auth-OpenId'] = '123'
  axios.defaults.headers['X-Auth-key'] = '0x84843A0239C734D6C74BEFC1563BB486'
  axios.defaults.headers['X-Auth-Source'] = 'pad'
  console.log(axios.defaults.headers)
  //
  //环境 1通用 2公用 3龙港 4.三江康养  5.国康 6.本地后端接口
  const flag = 2
  switch (flag) {
    case 1:
      axios.defaults.baseURL = 'https://yl.gtecs.cn/yl/hynotify/api'
      break
    case 2:
      axios.defaults.baseURL = 'https://hynotify.gshis.com/api'
      break
    case 3:
      axios.defaults.baseURL = 'http://172.16.200.9:96/api'
      break
    case 4:
      axios.defaults.baseURL = 'http://36.170.62.19:8015/api'
      break
    case 5:
      axios.defaults.baseURL = 'https://yl.hchina.com/yl/hynotify/api'
      break
    case 6:
      axios.defaults.baseURL = 'http://10.10.10.37:96/api'
      break

    default:
      break
  }

  axios.interceptors.request.use(
    (config) => {
      // const token = localStorage.getItem('token');
      // token && (config.headers.Authorization = token);
      return config
    },
    (error) => {
      return Promise.error(error)
    }
  )
  // 响应拦截器
  axios.interceptors.response.use(
    (response) => {
      errorNum = 0
      // 此处判断是为了兼容手持的的nfc刷卡和排除上传图片（response.config.data是formdata对象）
      const responseData = response.config.data && !(response.config.data instanceof FormData) && JSON.parse(response.config.data)
      if ((response.status === 200 && response.data.code == 1) || response.data.ok) {
        return Promise.resolve(response)
      } else {
        console.log('进去')
        Message({
          message: (responseData && responseData.errTip) || response.data.msg,
          type: 'error',
          customClass: 'custom-message'
        })
        return Promise.reject(response.data.msg)
      }
    },
    (error) => {
      errorNum++
      if (errorNum < 10) {
        //最多10次告警
        Message({
          duration: 2000,
          message: error.message.includes('Network Error') ? '网络异常' : error.message,
          type: 'error',
          customClass: 'custom-message'
        })
      }
      return Promise.reject(error)
    }
  )
}
// const service = axios.create({
//     baseURL: process.env.NODE_ENV == 'development' ?'/api':'https://hynotify.gshis.com/api',
//     timeout: 100000
//   })

// service.interceptors.request.use(
//   config => {
//       config.headers['X-Auth-Grpid'] = localStorage.getItem('grpid');
//       config.headers['X-Auth-ComId'] = localStorage.getItem('comId');
//       config.headers['X-Auth-OpenId'] = '123';
//       config.headers['X-Auth-key'] = '0x84843A0239C734D6C74BEFC1563BB486';
//       // config.headers['Content-Type'] = 'multipart/form-data';
//     return config
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )

// service.interceptors.response.use(
//   response => {
//       if (response.status === 200 && response.data.code==1 ) {
//           return Promise.resolve(response);
//       } else {
//           Message({
//               message:response.data.msg,
//               type:'error',
//               customClass:"custom-message"
//           })
//           return Promise.reject(response.data.msg);
//       }
//   },
//   error => {
//       Message({
//           duration:2000,
//           message:error||error.msg,
//           type:'error',
//           customClass:"custom-message"
//       })
//       return Promise.reject(error);
//   }
// )

export default { axios }



// WEBPACK FOOTER //
// ./src/request/http.js